/**
 * Articles dont l'image vit dans public/images/articles/{slug}.webp, hors de
 * la médiathèque (import de l'ancien site Bubble, scripts/download-article-images.sh).
 *
 * La liste est figée ici, et non lue sur le disque, parce que les fonctions
 * Vercel n'embarquent pas `public/` : un `existsSync` y répondrait toujours
 * « absent ». Le test scripts/tests/blog-couverture.test.ts vérifie qu'elle
 * reste identique au contenu du dossier.
 */
export const SLUGS_IMAGE_STATIQUE: ReadonlySet<string> = new Set([
  'adaptation-des-essences-forestieres-face-au-rechauffement-climatique-un-enjeu',
  'agriculture-comprendre-la-politique-agricole-commune-pac',
  'agriculture-environnement-et-politique-agricole-commune',
  'agriculture-grandes-cultures-optimisation-carbone',
  'carbone-et-foret-le-role-crucial-des-forets-francaises-dans-la-lutte-contre-le',
  'combien-coute-un-credit-carbone',
  'comment-calculer-son-bilan-carbone',
  'comment-collecter-et-traiter-efficacement-les-donnees-dun-bilan-carbone',
  'comment-fonctionnent-les-projets-de-reboisement-du-label-bas-carbone',
  'comment-integrer-les-criteres-esg-dans-votre-strategie-d-entreprise',
  'comment-la-biodiversite-en-foret-contribue-t-elle-a-la-gestion-durable-et-au',
  'comment-le-projet-du-bois-de-la-montagne-integre-la-performance-carbone-et-la',
  'comment-le-sol-participe-a-la-sequestration-dans-les-projets-bas-carbone',
  'comment-les-marges-de-securite-permettent-de-securiser-les-credits-carbone',
  'comment-les-projets-bas-carbone-forestiers-preservent-et-restaurent-la',
  'comment-stock-co2-securise-t-il-les-credits-carbone',
  'comparaison-des-standards-de-compensation-carbone-une-exploration-approfondie',
  'compensation-carbone-et-allegations-de-neutralite-dans-la-publicite',
  'compenser-les-emissions-residuelles-le-cas-du-giec-avec-stock-co2',
  'credits-carbone-les-10-cles-pour-comprendre',
  'credits-carbone-locaux-un-impact-superieur-aux-projets-internationaux',
  'des-assurances-pour-les-projets-bas-carbone-developpees-par-stock-co2-et',
  'dou-viennent-les-algues-vertes-en-bretagne',
  'engrais-azotes-cultiver-lavenir-sans-etouffer-la-planete',
  'eviter-reduire-et-compenser',
  'fertilite-des-sols-et-usage-dintrants-en-agriculture',
  'fiducie-stock-co2-un-outil-financier-pour-la-transition-ecologique-francaise',
  'forets-de-demain-rapport-pour-un-avenir-forestier-resilient',
  'glossaire-termes-et-concepts-essentiels-pour-les-projets-bas-carbone-et-la',
  'greenwashing-comprendre-et-distinguer-les-fausses-promesses-ecologiques',
  'haute-valeur-environnementale-hve',
  'incendie-dans-les-landes-quels-effets-positifs-du-reboisement-bas-carbone-du',
  'l-herbier-de-posidonie-une-solution-bas-carbone-pour-un-avenir-durable',
  'la-chalarose',
  'la-compensation-carbone-locale',
  'la-compensation-carbone-pour-les-compagnies-aeriennes-zoom-sur-le-decret-n-2022',
  'la-csrd-un-levier-pour-preserver-la-biodiversite',
  'la-foret-francaise-face-au-changement-climatique',
  'la-loi-du-22-aout-2021-une-arme-de-la-france-contre-le-dereglement-climatique',
  'la-magie-de-la-diversification-culturale',
  'la-magie-de-la-photosynthese-comment-nos-forets-absorbent-le-co2',
  'la-methanisation-enterique-des-bovins-comprendre-le-processus-et-ses',
  'la-neutralite-carbone',
  'lagriculture-raisonnee-une-solution-doublement-benefique-pour-les-agriculteurs',
  'le-bois-de-la-clef-un-boisement-exemplaire',
  'le-bois-des-quatre-rivieres-un-projet-bas-carbone-qui-allie-biodiversite-et',
  'le-carbone-bleu-proteger-nos-ecosystemes-marins-pour-combattre-le-rechauffement',
  'le-haut-conseil-pour-le-climat-analyse-et-implications-du-rapport-annuel-2023',
  'le-marche-du-carbone',
  'le-potentiel-de-lagriculture-dans-la-lutte-contre-le-changement-climatique',
  'les-bonnes-pratiques-de-la-transition-ecologique',
  'les-cobenefices-dun-projet-forestier-du-label-bas-carbone',
  'les-credits-carbone-francais-un-levier-essentiel-contre-le-changement-climatique',
  'les-credits-carbone-francais-un-levier-essentiel-contre-le-changement-climatique-2',
  'les-feux-de-forets-en-france-en-2022-comprendre-et-agir',
  'les-mangroves-des-remparts-naturels-contre-le-rechauffement-climatique',
  'limpact-de-la-rotation-des-cultures-sur-la-reduction-des-emissions-de-carbone',
  'mapping-des-labels-environnementaux-pour-les-entreprises',
  'operateur-de-compensation-carbone-quel-est-son-role-et-pourquoi-est-il-essentiel',
  'partenariat-butagaz-et-stock-co2-vers-un-territoire-bas-carbone',
  'pourquoi-diversifier-les-essences-dans-les-projets-forestiers-bas-carbone',
  'pourquoi-la-biodiversite-est-necessaire-aux-projets-du-label-bas-carbone',
  'pourquoi-le-label-bas-carbone-nest-pas-du-greenwashing',
  'pourquoi-les-credits-carbone-sont-ils-essentiels-dans-la-lutte-contre-le',
  'pourquoi-parle-t-on-de-contribution-carbone-plutot-que-de-compensation-carbone',
  'pourquoi-preserver-les-sols-dans-les-projets-de-contribution-carbone',
  'pourquoi-privilegier-la-compensation-carbone-locale',
  'pourquoi-suivre-regulierement-les-projets-bas-carbone',
  'qu-est-ce-qu-une-communication-responsable-en-entreprise',
  'qu-est-ce-que-la-methode-carbon-agri',
  'qu-est-ce-que-la-methode-de-boisement-du-label-bas-carbone',
  'qu-est-ce-que-la-methode-haies-du-label-bas-carbone',
  'qu-est-ce-que-la-methode-vergers',
  'qu-est-ce-que-le-carbone-noir',
  'quel-est-l-impact-concret-dune-demarche-rse-integrant-des-projets-de',
  'quel-est-le-role-de-lagriculture-dans-le-rechauffement-climatique',
  'quel-est-le-role-des-dreal-dans-linstruction-des-projets-bas-carbone',
  'quel-est-le-role-du-conseiller-technique-dans-les-projets-bas-carbone',
  'quelle-est-l-evolution-du-label-bas-carbone',
  'quelle-est-l-importance-de-l-eau-dans-les-projets-bas-carbone',
  'quelle-est-l-importance-de-la-biodiversite-dans-les-projets-bas-carbone',
  'quelle-est-l-importance-des-labels-dans-la-gestion-durable-des-forets',
  'quelle-est-l-importance-des-labels-dans-la-gestion-durable-des-forets-2',
  'quelles-evolutions-pour-les-operateurs-de-compensation-carbone',
  'quelles-sont-les-causes-et-consequences-des-maladies-et-ravageurs-en-foret',
  'quelles-sont-les-essences-d-arbres-qui-constituent-la-foret-francaise',
  'quelles-sont-les-tendances-regionales-du-carbone-en-france',
  'quels-impacts-les-tempetes-et-la-grele-ont-en-foret',
  'quels-sont-les-3-piliers-de-l-objectif-net-zero-initiative',
  'quels-sont-les-leviers-daction-en-grandes-cultures',
  'quels-sont-les-standards-de-certification-carbone-et-pourquoi-sont-ils',
  'quest-ce-que-la-chenille-processionnaire-du-pin',
  'quest-ce-que-la-methode-grandes-cultures',
  'quest-ce-que-la-methode-sobac-eco-tmm',
  'quest-ce-que-la-neutralite-carbone',
  'quest-ce-que-le-greenwashing',
  'quest-ce-que-lesg-au-sein-dune-entreprise',
  'quest-ce-que-net-zero-et-pourquoi-est-ce-crucial-pour-les-entreprises',
  'quest-ce-quun-puit-de-carbone',
  'quest-ce-quune-foret',
  'quota-carbone-vs-credit-carbone-quelle-est-la-difference',
  'reduire-les-emissions-de-ges-dans-lelevage-bovin-en-france-limportance-du-label',
  'regeneration-des-ecosystemes-un-levier-cle-pour-la-biodiversite-et-le-climat',
  'sante-et-climat-l-industrie-biopharmaceutique-au-defi-de-la-neutralite-carbone',
  'scolytes-petits-insectes-gros-degats',
  'stock-finance-le-reboisement-de-montrond-le-chateau',
  'vers-un-avenir-plus-vert-grace-au-label-bas-carbone-et-a-la-methode-grande',
])

export const aImageStatique = (slug: string | null | undefined): boolean => Boolean(slug && SLUGS_IMAGE_STATIQUE.has(slug))

export const urlImageStatique = (slug: string): string => `/images/articles/${slug}.webp`
